import {Typography} from "@mui/material"
import Grid from "@mui/material/Grid2";
import React from "react"
import {useDispatch, useSelector} from "react-redux"
import InfoIcon from '@mui/icons-material/Info'
import {setLid, unsetLid} from "../../../features/lid/lidSlice";
import {
    setIntermediateCeiling,
    unsetIntermediateCeiling
} from "../../../features/intermediateCeiling/intermediateCeilingSlice";
import {setVault, unsetVault, unsetStockVault} from "../../../features/vault/vaultSlice";
import {setStockVault} from "../../../features/vault/setStockVaultThunk";
import {setFloor, unsetFloor} from "../../../features/floor/floorSlice";
import {unsetStockFloor} from "../../../features/floor/floorSlice";
import {setStockFloor} from "../../../features/floor/setStockFloorThunk";
import {ImageButton} from "./ImageButton";
import floorImage from '../../../image/buttonImage/floor.jpg';
import lidImage from '../../../image/buttonImage/lid.jpg';
import vaultImage from '../../../image/buttonImage/vault.jpg'
import stockVaultImage from '../../../image/buttonImage/stockVault.jpg'
import stockFloorImage from '../../../image/buttonImage/stockFloor.jpg'
import intermediateCeilingImage from '../../../image/buttonImage/intermediate_ceiling.jpg'
import {getStockVaultDimensions} from "../../domain/vault";

const TitleGridItem = () => {
    return (
        <Grid size={12} sx={{width: '100%'}}>
            <Typography component="h1" variant="h4">
                Kabelschacht Konfigurator
            </Typography>
            < hr/>
        </Grid>
    )
}

const TextGridItem = () => {
    return (
        <Grid size={12} key={'upper_text'}>
            <Typography component="p" variant="body1">
                Konfigurieren Sie einen Kabelschacht genau nach Ihrer Vorstellung!
                Definiern Sie zuerst die Dimension und positionieren Sie anschliessend auf allen Seiten per Drag & Drop
                die gewünschten Elemente (z.B. Aussparungen, Muffen, C-Schienen, Abflüsse, Erdungsanschlüsse und
                Einstiegsöffnungen).
            </Typography>
        </Grid>
    )
}

const RemarksTextGridItem = () => {
    return (
        <Grid size={12}>
            <Grid direction={"row"} container alignItems={'center'}>
                <Grid>
                    <InfoIcon style={{marginRight: '1em'}}/>
                </Grid>
                <Grid size={10}>
                    <Typography component="p" variant="body1">
                        Mit einer 25 cm dicken Zwischendecke können Sie auch bei überbreiten Kabelschächten eine
                        Standard-Abdeckung
                        verwenden.
                        Die Gesamthöhe erhöht sich dementsprechend.
                    </Typography>
                </Grid>
            </Grid>
        </Grid>
    )
}

const ComponentButtonsGridItem = () => {
    const dispatch = useDispatch()
    const plan = useSelector(state => state.plan)
    const vault = useSelector(state => state.plan.vault)
    const customVault = !!vault && !vault.isStockVault ? vault : null
    const stockVault = !!vault && vault.isStockVault ? vault : null
    const lid = useSelector(state => state.plan.lid)
    const intermediateCeiling = useSelector(state => state.plan.intermediateCeiling)
    const floor = useSelector(state => state.plan.floor)
    const stockFloor = !!floor && floor.isStockFloor ? floor : null
    const customFloor = !!floor && !floor.isStockFloor ? floor : null
    const isStockFloorApplicable = () => getStockVaultDimensions().some(s =>
        plan.width === s.width
        && plan.length === s.length
        && plan.wallWidth === 15
    );

    return (
        <Grid size={12}>
            <Typography component="p" variant="body1" style={{marginBottom: '0.5em'}}>
                Was möchten Sie konfigurieren (Mehrfachauswahl)?
            </Typography>
            <Grid container direction={'row'} justifyContent={'flex-start'} spacing={3}>
                <Grid>
                    <ImageButton
                        title={'Abdeckung'}
                        checked={!!lid}
                        image={lidImage}
                        onClick={() => {
                            if (!!lid) {
                                dispatch(unsetLid())
                            } else {
                                dispatch(setLid())
                            }
                        }}
                    />
                </Grid>
                <Grid>
                    <ImageButton
                        title={'Zwischendecke'}
                        checked={!!intermediateCeiling}
                        image={intermediateCeilingImage}
                        onClick={() => {
                            if (!!intermediateCeiling) {
                                dispatch(unsetIntermediateCeiling())
                            } else {
                                dispatch(setIntermediateCeiling())
                            }
                        }}
                    />
                </Grid>
                <Grid>
                    <ImageButton
                        title={'Kabelschacht'}
                        checked={!!customVault}
                        image={vaultImage}
                        onClick={() => {
                            if (!!customVault) {
                                dispatch(unsetVault())
                            } else {
                                dispatch(setVault())
                            }
                        }}
                    />
                </Grid>
                <Grid>
                    <ImageButton
                        title={'Standard Kabelschacht'}
                        checked={!!stockVault }
                        image={stockVaultImage}
                        onClick={() => {
                            if (!!stockVault) {
                                dispatch(unsetStockVault())
                            } else {
                                dispatch(setStockVault())
                            }
                        }}
                    />
                </Grid>
                <Grid>
                    <ImageButton
                        title={'Boden'}
                        checked={!!customFloor}
                        image={floorImage}
                        onClick={() => {
                            if (!!customFloor) {
                                dispatch(unsetFloor())
                            } else {
                                dispatch(setFloor())
                            }
                        }}
                    />
                </Grid>
                <Grid>
                    <ImageButton
                        disabled={!isStockFloorApplicable()}
                        title={'Standard Boden'}
                        checked={!!stockFloor}
                        image={stockFloorImage}
                        onClick={() => {
                            if (!!stockFloor) {
                                dispatch(unsetStockFloor())
                            } else {
                                dispatch(setStockFloor())
                            }
                        }}
                    />
                </Grid>
            </Grid>
        </Grid>
    )
}

export const VaultElementsSection = () => {
    return (
        <Grid container spacing={3}>
            <TitleGridItem/>
            <TextGridItem/>
            <ComponentButtonsGridItem/>
            <RemarksTextGridItem/>
        </Grid>
    )
}
